import { render, staticRenderFns } from "./mainApp.vue?vue&type=template&id=5963036f&"
import script from "./mainApp.vue?vue&type=script&lang=js&"
export * from "./mainApp.vue?vue&type=script&lang=js&"
import style0 from "./mainApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports